module.exports = __webpack_public_path__ + "static/media/contract-sent.f3642cd4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/contract-sent.svg
// module id = 1415
// module chunks = 0